"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiMultiSelect = void 0;
const menu_1 = require("client/components/menu");
const option_1 = require("client/components/ui/multi-select/option");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./multi-select.less");
const ArrowDropDown_1 = require("@material-ui/icons/ArrowDropDown"); //E-037.2
const ArrowDropUp_1 = require("@material-ui/icons/ArrowDropUp"); //E-037.2
let UiMultiSelect = class UiMultiSelect extends react_1.Component {
    // E-037.211
    constructor(props) {
        super(props);
        this.showMenu = false;
        this.searchValue = "";
        // E-037.211
        this.handleIconClick = () => {
            if (this.props.disabled)
                return;
            this.showMenu = !this.showMenu;
        };
        this.handleFocus = () => {
            this.focused = true;
            this.textField.focus();
        };
        this.handleOnMenuAction = (item) => {
            if (this.props.disabled)
                return;
            // if (item) {
            //   // If an item was selected by user then update it
            //   this.searchValue = item.label;
            //   if (this.props.values.filter(i => i.id === item.id).length === 0) {
            //     this.props.values.push(item);
            //   }
            //   this.props.onChange && this.props.onChange(this.props.values);
            //   this.textField.value = "";
            //   this.textField.focus();
            //   this.showMenu = false;
            // }
            if (item) {
                // If an item was selected by user then update it
                this.searchValue = item.label;
                if (this.props.singleSelect) {
                    this.props.values.splice(0);
                    this.props.values.push(item);
                }
                else if (this.props.values.filter(i => i.id === item.id).length === 0) {
                    this.props.values.push(item);
                }
                this.props.onChange && this.props.onChange(this.props.values);
                this.textField.value = "";
                this.textField.focus();
                this.showMenu = false;
            }
        };
        this.handleOnChange = (event) => {
            const { value } = event.target;
            this.searchValue = value;
            this.props.onSearch && this.props.onSearch(this.searchValue);
        };
        this.handleOnOptionClick = (item) => {
            if (this.props.disabled)
                return;
            this.props.values.splice(this.props.values.findIndex(i => i.id === item.id), 1);
            this.props.onChange && this.props.onChange(this.props.values);
        };
        this.wrapperRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }
    get filteredOptions() {
        return this.props.options
            ? this.props.options.filter(o => o.label.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1)
            : [];
    }
    // E-037.211
    componentDidMount() {
        document.addEventListener("mousedown", this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener("mousedown", this.handleClickOutside);
    }
    // E-037.41
    handleClickOutside(event) {
        if (this.props.disabled) {
            this.showMenu = false;
            return;
        }
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target)) {
            this.showMenu = false;
        }
        if (this.props.name === 'patientReport') {
            this.showMenu = true;
        }
    }
    render() {
        const { label, required = false, values = [], missing, disabled = false } = this.props;
        const floatLabel = this.focused || this.props.values.length;
        const floatLabelClass = floatLabel ? "has-value" : "";
        const className = this.props.className || "";
        const isMissing = missing ? "multi-select--missing" : "";
        //E-037.2
        const customeStyle = {
            display: 'flex', alignItems: 'center', justifyContent: 'space-between'
        };
        return (React.createElement("div", { ref: this.wrapperRef, style: customeStyle, className: `multi-select ${className} ${floatLabelClass} ${isMissing}`, onBlur: () => {
                if (disabled)
                    return;
                this.showMenu = true; // E-037.211
            }, onClick: () => {
                if (disabled)
                    return;
                this.focused = true;
            }, onFocus: () => {
                if (disabled)
                    return;
                this.showMenu = true;
            } },
            React.createElement(menu_1.Menu, { className: this.props.name === "patientReport" ? "claimBackGrond" : "multi-select__select", data: this.props.onSearch ? this.props.options : this.filteredOptions, showMenu: disabled ? false : this.showMenu, onAction: this.handleOnMenuAction },
                React.createElement("a", { className: "multi-select__input" },
                    React.createElement("label", { className: this.props.name === "patientReport"
                            ? "pharmacyLabel"
                            : `multi-select__label ${floatLabelClass}` }, label),
                    React.createElement("div", { className: "multi-select__input-block" },
                        React.createElement("div", { className: this.props.name === "patientReport" ? "patientReporting" : this.props.name === "claimReport" ? "claimReporting" : "multi-select__options" },
                            values &&
                                values.map((v, i) => (React.createElement(option_1.Option, { key: i, disabled: disabled, item: v, onCloseClick: this.handleOnOptionClick }))),
                            React.createElement("input", { autoFocus: this.focused, className: `multi-select__text-input ${floatLabelClass}`, onChange: this.handleOnChange, disabled: disabled, ref: (input) => {
                                    this.textField = input;
                                }, required: required, onFocus: () => {
                                    if (disabled)
                                        return;
                                    this.handleFocus();
                                    this.searchValue = "";
                                    this.showMenu = true;
                                    this.props.onSearch &&
                                        this.props.onSearch(this.searchValue);
                                } }))))),
            this.showMenu ? React.createElement(ArrowDropUp_1.default, { onClick: this.handleIconClick }) : React.createElement(ArrowDropDown_1.default, { onClick: this.handleIconClick })));
    }
};
__decorate([
    mobx_1.computed
], UiMultiSelect.prototype, "filteredOptions", null);
__decorate([
    mobx_1.observable
], UiMultiSelect.prototype, "focused", void 0);
__decorate([
    mobx_1.observable
], UiMultiSelect.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], UiMultiSelect.prototype, "searchValue", void 0);
UiMultiSelect = __decorate([
    mobx_react_1.observer
], UiMultiSelect);
exports.UiMultiSelect = UiMultiSelect;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/multi-select/multi-select.tsx
// module id = 3666
// module chunks = 0